import { DefaultService } from '@/services/DefaultService';

export default class MotivoVisitaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(lps) {
        return this._http.post(`${this._env}/promotor/motivovisita`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/motivovisita/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/motivovisita/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/motivovisita.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(motivovisita) {
        return this._http
            .post(`${this._env}/promotor/motivovisita/updatesituacao`, motivovisita, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
